<template>

    <div class="right-contx bgcolor-f6f5fa pull-right">
        <div class="top-titx font-16">当前用户：
            <span class="color-999" id="loginAccount">142623****6119</span>
        </div>
        <div class="set-20180409-ccj">
            <div class="item">
                <h2 class="title font-16"><i></i>修改密码</h2>
                    <div id="js_updata_form" class="form-ele-box form-inline-box">
                        <div class="form-item clearfix">
                            <label class="form-label">输入旧登录密码：</label>
                            <div class="form-inp-area">
                                <el-input v-model="oldPassword" show-password placeholder="请输入旧登录密码"></el-input>
                            </div>
                        </div>
                        <div class="form-item clearfix">
                            <label class="form-label">输入新登录密码：</label>
                            <div class="form-inp-area">
                                <el-input v-model="newPassword" show-password placeholder="请输入新登录密码"></el-input>
                            </div>
                        </div>
                        <div class="form-item clearfix">
                            <label class="form-label">再次输入新密码：</label>
                            <div class="form-inp-area">
                                <el-input v-model="againPassword" show-password placeholder="请再次输入新密码"></el-input>
                            </div>
                        </div>
                        <div class="form-item clearfix">
                            <label class="form-label"></label>
                            <button class="form-btn form-btn-blue" @click="updatePassWord()">确认修改
                            </button>
                        </div>
                    </div>
            </div>
        </div>
    </div>


</template>

<script>
    export default {
        name: 'app',
        components: {

        },
        data() {
            return {
                oldPassword: '',
                newPassword: '',
                againPassword: ''
            }
        },
        created() {
            console.log(this.$storage.get("declareUser"));

            md5('holle')
            if (this.$storage.get("declareUser") === undefined) {
                this.$confirm('请先登录！').then(_ => {
                    this.$router.push('/login');
                }).catch(_ => { });
            }
        },
        mounted() {

        },
        beforeDestroy() {

        },
        methods: {
            updatePassWord() {
                if(this.oldPassword === ''){
                    this.$message({
                            message: '请输入旧密码！',
                            offset: 100,
                            type: 'warning',
                            duration: 1500
                        });
                        return false;
                }else if(this.newPassword === ''){
                    this.$message({
                            message: '请输入新密码',
                            offset: 100,
                            type: 'warning',
                            duration: 1500
                        });
                        return false;
                }else if(this.againPassword === ''){
                    this.$message({
                            message: '请再次输入新密码！',
                            offset: 100,
                            type: 'warning',
                            duration: 1500
                        });
                        return false;
                }else if(this.newPassword != this.againPassword){
                    this.$message({
                            message: '两次密码输入不一致！',
                            offset: 100,
                            type: 'warning',
                            duration: 1500
                        });
                        return false;
                }

                let parames = new URLSearchParams();
                parames.append('id', this.$storage.get("declareUser").id);
                parames.append('passWord', this.newPassword);
                parames.append('o_passWord', this.oldPassword);
                

                this.$axios.post(this.serverUrl + '/updatePassWord', parames).then(resp => {

                    if (resp.data.code === 1) {

                        this.$message({
                            message: '修改成功',
                            offset: 100,
                            type: 'success',
                            duration: 1500
                        });

                        setTimeout(() => {
                            this.$router.push({path:'/login'})
                        }, 1000);
                    }else if(resp.data.code === 3){
                        this.$message({
                            message: '原始密码错误！',
                            offset: 100,
                            type: 'warning',
                            duration: 1500
                        });
                    }
                }).catch(err => {
                    this.$message({
                        message: '服务器繁忙！',
                        type: 'warning'
                    });
                })



            }



        }
    }
</script>

<style scoped>
    .form-btn {
        display: inline-block;
        padding: 6px 12px;
        margin-bottom: 0;
        font-size: 14px;
        font-weight: normal;
        line-height: 1.42857143;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-image: none;
        border: 1px solid transparent;
        border-radius: 4px;
        height: 40px;
    }

    .form-btn-blue {
        color: #fff;
        background-color: #4b95ff;
        border-color: #4b95ff;
    }

    .form-ele-box .form-item {
        margin-bottom: 18px;
    }

    .form-ele-box.form-inline-box .form-inp-area {
        width: 340px;
        float: left;
    }

    .form-ele-box.form-inline-box .form-label {
        float: left;
        text-align: right;
        width: 100px;
        margin-right: 15px;
        margin-bottom: 0;
        height: 40px;
        line-height: 38px;
    }

    .form-ele-box .form-item {
        margin-bottom: 18px;
    }

    .form-ele-box {
        font-size: 14px;
    }

    .set-20180409-ccj .item .title>i {
        background-color: #4d95ff;
        padding-left: 4px;
        margin-right: 10px;
    }

    .set-20180409-ccj .item .title {
        font-weight: 700;
        margin-bottom: 20px;
    }

    .set-20180409-ccj .item {
        padding: 28px;
    }

    .color-999 {
        color: #999;
    }

    .font-16 {
        font-size: 16px;
    }

    .md-2018040807-xxw .top-titx {
        padding: 0 !important;
    }

    .md-2018040807-xxw .top-titx {
        line-height: 60px;
        padding: 0 28px;
        border-bottom: 1px solid #ddd;
    }

    .bgcolor-f6f5fa {
        background-color: unset !important;
    }

    .pull-right {
        float: right;
    }

    .bgcolor-f6f5fa {
        background: #f6f5fa;
    }

    .md-2018040807-xxw .right-contx {
        width: 940px;
        min-height: 450px;
        padding-bottom: 34px;
        border-radius: 4px;
    }
</style>


// WEBPACK FOOTER //
// src/components/train/personalCenter/resetThePassword.vue